module.exports = __webpack_public_path__ + "static/media/moneybox.8958625b.svg";